import { Button, Icon, Modal, Tabs } from 'antd'
import React, { Component } from 'react'
import { Fragment } from 'react'
import { withTranslation } from 'react-i18next'
import { CAMPAIGN, DETAIL_ACTIONS, ORDER, PATHS } from '../../../../../../constants/Define'
import Wrapper from '../../../../common/component/Wrapper'
import { merge, get, intersection, isEqual } from 'lodash'
import DualListBox from 'react-dual-listbox'
import AntSelect, { AntOption } from '../../../../common/component/AntSelect'
import * as Func from '../../../../../../helpers/functions'
import * as TagService from '../../../../../../services/tagService'

import './ListSKU.less'

const { TabPane } = Tabs;

const SkuTypes = [
    ORDER.TYPES.VOUCHER,
    ORDER.TYPES.TOUR,
    ORDER.TYPES.VINWONDER,
    // ORDER.TYPES.HOTEL,
]

const MappingProductTypes = {
    [ORDER.TYPES.VOUCHER.key]: CAMPAIGN.PRODUCT_TYPE.VOUCHER,
    [ORDER.TYPES.TOUR.key]: CAMPAIGN.PRODUCT_TYPE.TOUR,
    [ORDER.TYPES.VINWONDER.key]: CAMPAIGN.PRODUCT_TYPE.VINWONDER,
}

const HIDE_SUPPLIER_FILTER_TABS = [ORDER.TYPES.VINWONDER.key];

let permisionActions = [];

class ListSKU extends Component {

    constructor(props) {
        super(props)
        this.supplierFilterTimers = {};
        this.state = {
            visible: false,
            activeType: ORDER.TYPES.VOUCHER.key,
            action: DETAIL_ACTIONS.CREATE,
            isSubmit: false,
            isGetItem: false,
            validation: {},
            skuSelected: this.props.skuIds || [],
            supplierFilters: {},
            appliedSupplierFilters: {},
            panelSkus: {},
            skuOptionsByType: {}
        }
    }

    componentWillUnmount() {
        Object.values(this.supplierFilterTimers).forEach(timer => {
            if (timer) {
                clearTimeout(timer);
            }
        });
    }

    componentDidMount() {
        const { productTypes, getSupplierAll } = this.props;
        const removedProductType = productTypes && productTypes.length > 0 && productTypes.includes(CAMPAIGN.PRODUCT_TYPE.SKU.id) ?
            productTypes.filter(item => { return item !== CAMPAIGN.PRODUCT_TYPE.SKU.id } ) : productTypes;
        const mappingData = MappingProductTypes[removedProductType && removedProductType.length > 0 ? removedProductType[0].toLowerCase() : ''];
        const key = mappingData?.key;
        this.setState({ activeType: key });
        this.props.getAllSku(key);
        getSupplierAll && getSupplierAll({ productType: 7 });
    }

    componentDidUpdate(prevProps) {
        const prevSkus = prevProps.tagGroupDetailState.skus || {};
        const nextSkus = this.props.tagGroupDetailState.skus || {};

        if (prevSkus !== nextSkus) {
            let shouldUpdate = false;
            const nextSkuOptionsByType = { ...this.state.skuOptionsByType };
            const nextPanelSkus = { ...this.state.panelSkus };

            Object.keys(nextSkus).forEach(typeKey => {
                if (prevSkus[typeKey] !== nextSkus[typeKey]) {
                    const mergedOptions = this.mergeSkuOptions(nextSkuOptionsByType[typeKey], nextSkus[typeKey]);
                    nextSkuOptionsByType[typeKey] = mergedOptions;

                    const currentPanels = nextPanelSkus[typeKey] || {};
                    nextPanelSkus[typeKey] = {
                        available: currentPanels.available || nextSkus[typeKey],
                        selected: currentPanels.selected || nextSkus[typeKey],
                    };
                    shouldUpdate = true;
                }
            });

            if (shouldUpdate) {
                this.setState({
                    skuOptionsByType: nextSkuOptionsByType,
                    panelSkus: nextPanelSkus,
                });
            }
        }
    }

    render() {
        
        const { t, tagGroupDetailState, supplierState, className, buttonText, productTypes = [] } = this.props;
        const { action, isSubmit, isGetItem, validation, activeType } = this.state;
        const supplierOptions = supplierState?.supplierAll || [];

        const renderTypes = SkuTypes.filter(item => (productTypes || []).indexOf(MappingProductTypes[item.key]?.value) >= 0);
        return (
            <Fragment>
                <Button className={className} type="primary" onClick={this.showModal}>
                    {buttonText || 'Chọn sản phẩm áp dụng'}
                </Button>
                <Modal
                    title="Chọn sản phẩm áp dụng"
                    width={1200}
                    visible={this.state.visible}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    maskClosable={false}
                >
                    <Tabs activeKey={activeType} onChange={this.onChangeType} type="card" className="list-sku-tab" >
                        {renderTypes.map(item => (
                            <TabPane tab={MappingProductTypes[item.key]?.label || t(`item.order.orderTypes.${item.key}`)} key={item.key} className="bg-white pt-3 px-3">
                                {!HIDE_SUPPLIER_FILTER_TABS.includes(item.key) && (
                                    <Wrapper className='list-sku-supplier-row'>
                                        <Wrapper className='list-sku-supplier-field'>
                                            <div className='list-sku-supplier-label'>{t(`item.campaign.supplierName`)}</div>
                                            <AntSelect
                                                showArrow
                                                showSearch
                                                allowClear
                                                mode="multiple"
                                                value={this.getSupplierFilterValue(item.key, 'available')}
                                                placeholder={this.getSupplierPlaceholder()}
                                                style={{ width: '100%' }}
                                                filterOption={this.selectFilterSearch}
                                                onChange={values => this.onChangeSupplierFilter(item.key, 'available', values)}
                                                onBlur={() => this.onBlurSupplierFilter(item.key, 'available')}
                                                onDropdownVisibleChange={open => this.onChangeSupplierDropdownVisible(item.key, 'available', open)}
                                            >
                                                {supplierOptions.map(supplier => (
                                                    <AntOption key={supplier.id} value={supplier.id}>
                                                        {supplier.supplierName}
                                                    </AntOption>
                                                ))}
                                            </AntSelect>
                                        </Wrapper>
                                        <Wrapper className='list-sku-supplier-spacer' />
                                        <Wrapper className='list-sku-supplier-field'>
                                            <div className='list-sku-supplier-label'>{t(`item.campaign.supplierName`)}</div>
                                            <AntSelect
                                                showArrow
                                                showSearch
                                                allowClear
                                                mode="multiple"
                                                value={this.getSupplierFilterValue(item.key, 'selected')}
                                                placeholder={this.getSupplierPlaceholder()}
                                                style={{ width: '100%' }}
                                                filterOption={this.selectFilterSearch}
                                                onChange={values => this.onChangeSupplierFilter(item.key, 'selected', values)}
                                                onBlur={() => this.onBlurSupplierFilter(item.key, 'selected')}
                                                onDropdownVisibleChange={open => this.onChangeSupplierDropdownVisible(item.key, 'selected', open)}
                                            >
                                                {supplierOptions.map(supplier => (
                                                    <AntOption key={supplier.id} value={supplier.id}>
                                                        {supplier.supplierName}
                                                    </AntOption>
                                                ))}
                                            </AntSelect>
                                        </Wrapper>
                                    </Wrapper>
                                )}
                                <Wrapper className='w-100'>
                                    <DualListBox
                                        canFilter showHeaderLabels
                                        filterPlaceholder={t('action.search')}
                                        options={this.getDualListOptions(item.key)}
                                        available={this.getAvailableValues(item.key)}
                                        selected={this.getDisplayedSelectedValues(item.key)}
                                        onChange={this.onChangeSkus}
                                        filterCallback={this.onFilter}
                                        lang={{
                                            availableHeader: t('item.tagGroupDetails.skuAvailable'),
                                            selectedHeader: t('item.tagGroupDetails.skuSelected'),
                                        }}
                                        icons={{
                                            moveLeft: <Icon type="left" className="mx-2" />,
                                            moveAllLeft: <Icon type="double-left" className="mx-2" />,
                                            moveRight: <Icon type="right" className="mx-2" />,
                                            moveAllRight: <Icon type="double-right" className="mx-2" />,
                                        }}
                                    />
                                </Wrapper>
                            </TabPane>
                        ))}
                    </Tabs>
                </Modal>
            </Fragment>
        )
    }

    showModal = () => {
        this.setState({ visible: true });
    };

    handleOk = () => {
        this.props.onChange(this.state.skuSelected.map(item => item))
        this.setState({ visible: false });
    };

    handleCancel = () => {
        this.setState({ visible: false });
    };

    onChangeType = (key) => {
        const { tagGroupDetailState } = this.props;
        const skus = tagGroupDetailState.skus[key] || []
        this.setState({ activeType: key });
        if (!skus.length) {
            this.props.getAllSku(key)
        }
    }

    onChangeSkus = (selectedIds) => {
        const displayedSelectedIds = this.getDisplayedSelectedValues(this.state.activeType);
        const hiddenSelectedIds = this.state.skuSelected.filter(item => !displayedSelectedIds.includes(item));
        const nextSelectedIds = Array.from(new Set([...selectedIds, ...hiddenSelectedIds]));

        this.setState({ skuSelected: nextSelectedIds });
    }

    onChangeSupplierFilter = (typeKey, targetKey, values = []) => {
        const currentValues = this.getSupplierFilterValue(typeKey, targetKey);
        const shouldApplyImmediately = currentValues.length > 0 && values.length === 0;

        this.setState(prevState => ({
            supplierFilters: {
                ...prevState.supplierFilters,
                [typeKey]: {
                    ...this.getSupplierFilter(typeKey, prevState.supplierFilters),
                    [targetKey]: values,
                },
            },
        }), () => {
            if (shouldApplyImmediately) {
                this.scheduleApplySupplierFilter(typeKey, targetKey, values, 0);
                return;
            }

            this.scheduleApplySupplierFilter(typeKey, targetKey, values);
        });
    }

    onBlurSupplierFilter = async (typeKey, targetKey) => {
        const nextValues = this.getSupplierFilterValue(typeKey, targetKey);
        await this.scheduleApplySupplierFilter(typeKey, targetKey, nextValues, 0);
    }

    onChangeSupplierDropdownVisible = (typeKey, targetKey, open) => {
        if (!open) {
            this.onBlurSupplierFilter(typeKey, targetKey);
        }
    }

    applySupplierFilter = async (typeKey, targetKey, nextValues = []) => {
        const appliedValues = this.getAppliedSupplierFilterValue(typeKey, targetKey);

        if (isEqual([...nextValues].sort(), [...appliedValues].sort())) {
            return;
        }

        try {
            const nextParams = nextValues.length > 0 ? { supplierIds: nextValues } : {};
            const nextSkus = await TagService.getAllSku(typeKey, nextParams);

            this.setState(prevState => ({
                panelSkus: {
                    ...prevState.panelSkus,
                    [typeKey]: {
                        ...this.getPanelSkuByType(typeKey, prevState.panelSkus),
                        [targetKey]: nextSkus,
                    },
                },
                skuOptionsByType: {
                    ...prevState.skuOptionsByType,
                    [typeKey]: this.mergeSkuOptions(prevState.skuOptionsByType[typeKey], nextSkus),
                },
                appliedSupplierFilters: {
                    ...prevState.appliedSupplierFilters,
                    [typeKey]: {
                        ...this.getSupplierFilter(typeKey, prevState.appliedSupplierFilters),
                        [targetKey]: [...nextValues],
                    },
                },
            }));
        } catch (e) {
            return;
        }
    }

    scheduleApplySupplierFilter = (typeKey, targetKey, nextValues = [], delay = 400) => {
        const timerKey = `${typeKey}-${targetKey}`;

        if (this.supplierFilterTimers[timerKey]) {
            clearTimeout(this.supplierFilterTimers[timerKey]);
            delete this.supplierFilterTimers[timerKey];
        }

        if (delay <= 0) {
            return this.applySupplierFilter(typeKey, targetKey, nextValues);
        }

        this.supplierFilterTimers[timerKey] = setTimeout(() => {
            delete this.supplierFilterTimers[timerKey];
            this.applySupplierFilter(typeKey, targetKey, nextValues);
        }, delay);
    }

    onFilter = (option, filterInput) => {
        if (filterInput === '') {
            return true;
        }
        const optionText = Func.vietnameseStringToUnicode(option.label.toLowerCase());
        const inputText = Func.vietnameseStringToUnicode(filterInput.toLowerCase());
        const codeText = Func.vietnameseStringToUnicode(option.code.toLowerCase());
        return optionText.indexOf(inputText) >= 0 || optionText.indexOf(inputText) >= 0;
    }

    selectFilterSearch = (input, option) => {
        const optionText = Func.vietnameseStringToUnicode(String(option.props?.children || '').toLowerCase());
        const inputText = Func.vietnameseStringToUnicode(input.toLowerCase());
        return optionText.indexOf(inputText) >= 0;
    };

    onClickBack = () => {
        const path = Func.getPathWithParams(PATHS.TAG_GROUP_DETAIL.DETAIL.path, { id: get(this.props, 'match.params.id') })
        this.props.history.push(path);
    }

    getSelectedSkus = (skuItemEnum) => {
        const { skuSelected } = this.state;
        return skuSelected.filter(item => !item.type || !skuItemEnum || item.type === skuItemEnum.id)
    }

    getSelectedIds = (skuItemEnum, withIntersection = false) => {
        const { tagGroupDetailState } = this.props;
        const selectedSkus = this.state.skuSelected;
        const selectedIds = selectedSkus.map(item => item.skuId)
        if (!withIntersection) {
            return selectedIds
        }
        const allIds = (tagGroupDetailState.skus[skuItemEnum.key] || []).map(item => item.skuId)
        return intersection(selectedIds, allIds)
    }

    getSupplierFilter = (typeKey, supplierFilters = this.state.supplierFilters) => {
        return supplierFilters[typeKey] || { available: [], selected: [] };
    }

    getSupplierFilterValue = (typeKey, targetKey) => {
        return this.getSupplierFilter(typeKey)[targetKey] || [];
    }

    getAppliedSupplierFilterValue = (typeKey, targetKey) => {
        return this.getSupplierFilter(typeKey, this.state.appliedSupplierFilters)[targetKey] || [];
    }

    getPanelSkuByType = (typeKey, panelSkus = this.state.panelSkus) => {
        const defaultSkus = this.props.tagGroupDetailState.skus[typeKey] || [];
        return panelSkus[typeKey] || { available: defaultSkus, selected: defaultSkus };
    }

    getPanelSkuValues = (typeKey, targetKey) => {
        return this.getPanelSkuByType(typeKey)[targetKey] || [];
    }

    getSkuOptionsByType = (typeKey) => {
        return this.state.skuOptionsByType[typeKey] || this.props.tagGroupDetailState.skus[typeKey] || [];
    }

    getDualListOptions = (typeKey) => {
        return this.getSkuOptionsByType(typeKey).map(item => merge(item, { label: `[${item.code}] ${item.name}`, value: item.id }));
    }

    getAvailableValues = (typeKey) => {
        const allSelectedIds = new Set(this.state.skuSelected);
        return this.getPanelSkuValues(typeKey, 'available')
            .map(item => item.id)
            .filter(id => !allSelectedIds.has(id));
    }

    getDisplayedSelectedValues = (typeKey) => {
        const selectedFilterValues = this.getAppliedSupplierFilterValue(typeKey, 'selected');
        const allSelectedIds = this.state.skuSelected;

        if (selectedFilterValues.length <= 0) {
            return allSelectedIds;
        }

        const selectedPanelIds = new Set(
            this.getPanelSkuValues(typeKey, 'selected').map(item => item.id)
        );

        return allSelectedIds.filter(id => selectedPanelIds.has(id));
    }

    mergeSkuOptions = (oldOptions = [], newOptions = []) => {
        const optionMap = new Map();

        [...oldOptions, ...newOptions].forEach(item => {
            if (item?.id) {
                optionMap.set(item.id, item);
            }
        });

        return Array.from(optionMap.values());
    }

    getSupplierPlaceholder = () => {
        const { t } = this.props;
        return Func.capitalizeFirstLetter((t('placeHolderForm.select') + ' ' + t('item.campaign.supplierName')).toLowerCase());
    }
}

export default withTranslation()(ListSKU)
